module.exports = __webpack_public_path__ + "static/media/ChronosSerif-Filled.a59710c6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ChronosSerif-Filled.woff
// module id = 2247
// module chunks = 50